import {Component} from "../interface/component";

export class FormSignUpComponent implements Component {
    private $root: JQuery;
    private $form: JQuery;
    private $messages: JQuery;
    private action: string;

    private $field_errors: JQuery;

    private $loading:JQuery;

    private redirect_on_success: boolean;
    private redirect_on_success_url: string;
    private generic_error_message: string;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.$form = this.$root.find('.js-signup-form__form');
        this.$messages = this.$root.find('.js-signup-form__messages');
        this.action = this.$form.attr('action');
        this.$field_errors = this.$form.find('.js-signup-field-error');
        this.$loading = this.$form.find('.js-signup-form__submit-status');

        //!! intentional for casting purposes
        this.redirect_on_success = !!this.$root.data('success-should-redirect');
        this.redirect_on_success_url = this.$root.data('success-redirect-url');
        this.generic_error_message = this.$root.data('generic-error-message');
    }

    init() {
        this.$form.on('submit', this.submitHandler);
    }

    private submitHandler = (ev: Event) => {
        ev.preventDefault();
        this.clearFieldErrors();
        this.clearMessages();

        $.ajax({
            type: "POST",
            url: this.action,
            data: this.$form.serialize(),
            success: this.responseHandler,
            error: this.showFormGenericErrorMessage,
            dataType: 'json'
        });
    }

    private responseHandler = (data: any) => {
        if (data.status == 'success') {
            if (this.redirect_on_success){
                window.location.href = this.redirect_on_success_url;
            }else {
                this.showSuccessMessage(data.message);
            }
        }else{
            this.handleErrorResponse(data);
        }
    }

    private handleErrorResponse = (data:any) => {
        this.showFormGenericErrorMessage();

        if (undefined != data.errors){

            if (undefined != data.errors.field) {
                this.handleFieldErrors(data.errors.field);
            }

            if (undefined != data.errors.form){
                data.errors.form.map(this.appendNewErrorMessage);
            }
        }
    }

    private clearFieldErrors = () => {
        this.$field_errors.removeClass('active');
        this.$field_errors.html('');
    }

    private handleFieldErrors = (errors: any) => {
        for (const i in errors){
            let $field = this.$field_errors.filter('[data-field='+i+']');
            let $message = $('<p></p>');
            $field.html('');
            $message.html(errors[i]);
            $field.append($message);
            $field.addClass('active');
        }
    }

    private showFormGenericErrorMessage = () => {
        this.showErrorIntro(this.generic_error_message);
    }

    private clearMessages = () => {
        this.$messages.html('');
        this.$messages.removeClass([' c-form-messages--fail', ' c-form-messages--success']);
        this.$messages.attr('aria-hidden', 'true');
    }

    private showErrorIntro = (message: string) => {
        this.$messages.addClass('c-form-messages--fail');
        this.$messages.attr('aria-hidden', 'false');
        this.appendNewErrorMessage(message);
    }

    private showSuccessMessage = (message: string) => {
        this.$messages.addClass('c-form-messages--success');
        this.$messages.attr('aria-hidden', 'false');
        this.appendNewSuccessMessage(message);
    }

    private getMessageShowCallback = ($message: JQuery) => {
        return () => {
            $message.addClass('c-message--show');
        };
    }

    private appendNewMessage = (type_class: string) => {
        return (message: string) => {
            if (message && message.length > 0) {
                let $message = $('<div class="c-message"></div>');
                let $message_inner = $('<p></p>');
                $message_inner.html(message);
                $message.addClass(type_class);
                $message.append($message_inner);
                this.$messages.append($message);

                setTimeout(this.getMessageShowCallback($message), 100);
            }
        }
    }

    private appendNewErrorMessage = this.appendNewMessage('c-message--fail');
    private appendNewSuccessMessage = this.appendNewMessage('c-message--success');
}